var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DatePicker } from '@hn-ui/datepickers';
import { styled } from 'styled-components';
import { DatePickerInput } from './DatePickerInput';
import { useCallback, useRef, useState } from 'react';
import { useWeeklyDashboardAnalytics, WeeklyDashboardEvents, } from '../../hooks/useWeeklyDashboardAnalytics';
import { formatWeekRange } from '../../utils/dateTime';
import { PastWeekNotice } from '../PastWeekNotice';
var DatePickerContainer = styled.div.withConfig({ displayName: "DatePickerContainer", componentId: "sc-1j1tn2t" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var CalendarNotice = styled(PastWeekNotice).withConfig({ displayName: "CalendarNotice", componentId: "sc-eyft7d" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 26px;\n"], ["\n  margin-left: 26px;\n"])));
var WeeklyDatesFilter = function (_a) {
    var calendarData = _a.calendarData, onChange = _a.onChange, minDate = _a.minDate, backToCurrentWeek = _a.backToCurrentWeek, children = _a.children, rest = __rest(_a, ["calendarData", "onChange", "minDate", "backToCurrentWeek", "children"]);
    var sendGAEvent = useWeeklyDashboardAnalytics();
    var datepickerRef = useRef();
    var _b = useState(false), closeOnClick = _b[0], setCloseOnClick = _b[1];
    var onCalendarClick = useCallback(function () {
        var _a, _b, _c;
        sendGAEvent(WeeklyDashboardEvents.datepickerClick);
        if (closeOnClick) {
            (_a = datepickerRef.current) === null || _a === void 0 ? void 0 : _a.toggleCalendar();
        }
        else if (!((_b = datepickerRef.current) === null || _b === void 0 ? void 0 : _b.state.open)) {
            (_c = datepickerRef.current) === null || _c === void 0 ? void 0 : _c.setOpen(true);
        }
    }, [closeOnClick, sendGAEvent]);
    var currentDate = calendarData.currentDate, isWeekInThePast = calendarData.isWeekInThePast, weekRange = calendarData.weekRange;
    var start = weekRange[0], end = weekRange[1];
    return (_jsxs(DatePickerContainer, __assign({}, rest, { children: [_jsx(DatePicker, { ref: datepickerRef, type: 'week', startDate: start, endDate: end, onChange: function (_a) {
                    var date = _a[0];
                    onChange(date);
                }, onCalendarVisibilityChange: function (open) {
                    setTimeout(function () {
                        setCloseOnClick(open);
                    }, 100);
                }, customInput: _jsx(DatePickerInput, __assign({ onInputClick: onCalendarClick }, { children: formatWeekRange(weekRange[0], weekRange[1]) }), void 0), minDate: minDate, maxDate: currentDate, popperOffset: [0, 0], popperPlacement: 'bottom-start' }, void 0), isWeekInThePast && _jsx(CalendarNotice, { onBackClick: backToCurrentWeek }, void 0), children] }), void 0));
};
export { WeeklyDatesFilter };
var templateObject_1, templateObject_2;
